import { useEffect, useState } from "react";
import { Container } from "../../common/components/container/Container";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { Radio } from "antd";
import { MaterialConstant } from "./core/_constant";
import { MaterialService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../common/components/Loader/Loader";
import { useSearchParams } from "react-router";
import { MaterialDataTypeInterface } from "./core/_model";
import { Assets } from "../../assets";
import { TypeCard } from "./components/TypeCard/TypeCard";
import style from "./style.module.scss"

export const MaterialPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialTransportType =
    searchParams.get("type")?.toLowerCase() ||
    MaterialConstant.MATERIAL_TYPE_OPTIONS[0]?.value.toLowerCase();

  const [selectedTransportType, setSelectedTransportType] = useState<string>(
    initialTransportType.toUpperCase()
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [materialType, setMaterialType] = useState<Array<any>>([]);

  useEffect(() => {
    getSubTypeOfTransport(selectedTransportType);
  }, [selectedTransportType]);

  const getSubTypeOfTransport = async (id: string) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getMaterialTypes({ id });
      if (res?.status === HttpStatusCode.Ok) {
        setMaterialType(formatDataMaterialType(res?.data?.member));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDataMaterialType = (data: Array<MaterialDataTypeInterface>) => {
    return data?.map((item: MaterialDataTypeInterface) => ({
      ...item,
      icon: (Assets.iconsSvg as any)?.[
        ((item.materialType as any)?.["id"] as string).toLowerCase()
      ] as any,
    }));
  };

  const handleChangeTransportType = (value: any) => {
    const newType = value?.target?.value;
    setSelectedTransportType(newType);
    setSearchParams({ type: newType?.toLowerCase() });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <div className="">
        <TitleHeader title="Matériels" />
      </div>

      <div className="d-flex material">
        <div className="flex-full mt-4">
          <Radio.Group
            block
            options={MaterialConstant.MATERIAL_TYPE_OPTIONS}
            optionType="button"
            buttonStyle="solid"
            value={selectedTransportType}
            onChange={handleChangeTransportType}
          />
        </div>
        <div className="flex-full"></div>
      </div>
      <Container className={style.material_container}>
        <div className={style.type_grid}>
          {materialType?.map((item: any, index: number) => (
            <TypeCard
              key={index}
              iconUri={item?.icon}
              title={item?.materialType?.name}
              path={item?.materialType?.id?.toLowerCase()}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};
